import { assign } from 'lodash'
import { warning, success } from '@/utils/alert'

export default {
  doSave () {
    const password = assign({}, this.password)
    if (password.password !== password.confirmed) {
      return warning('As senhas não conferem!')
    }

    this.$http.post('/v1/dweller/me/password', password)
      .then(({data}) => {
        this.password = {
        }
        this.show = true
        success('Sua senha foi alterada com sucesso.')
      })
      .catch(({data, meta}) => {
        console.log(meta)
        this.errors = data
        warning(meta.message)
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/change-password/resources/methods.js